import {
  Modal,
  Card,
  Portal,
  Typography,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import Order from "../../models/order";

type Props = {
  order: Order;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const DeleteOrderModal: React.FC<Props> = ({
  open,
  onConfirm,
  onCancel,
  order,
}) => {
  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = () => {
    onConfirm();
  };

  return (
    <Portal>
      <Modal
        keepMounted
        open={open}
        onClose={handleCancel}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Card
          sx={{
            position: "absolute",
            juistifyContent: "center",
            alighItems: "center",
            maxWidth: 400,
            minWidth: 340,
            borderWidth: 0,
            padding: 2,
          }}
        >
          <CardContent>
            <Typography id="modal-title" variant="h6" component="h2">
              Eliminar pedido
            </Typography>
            <Typography id="modal-description" sx={{ mt: 1 }}>
              Esta seguro de eliminar el pedido del
              cliente: <b>{order.name}</b>?
            </Typography>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <Button onClick={handleCancel} variant="text">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="error">
              Sí, Eliminar
            </Button>
          </CardActions>
        </Card>
      </Modal>
    </Portal>
  );
};

export default DeleteOrderModal;
